@let activitesSelectionnees = form().value.activites ?? [];
<div class="pb-lg gap-lg grid">
  <app-expansion-panel [isOpen]="!!activitesSelectionnees.length" titre="Activités liées">
    <div class="ml-sm gap-sm flex" ngProjectAs="chipRight">
      <app-chip [label]="activitesSelectionnees.length | i18nPlural: activiteMapping" />
    </div>
    <div class="py-md px-lg gap-sm flex">
      @for (activite of activitesSelectionnees; track activite.id) {
        <app-chip-filtering [label]="activite.nom" variant="informative" />
      } @empty {
        Aucune activité liée.
      }
    </div>
  </app-expansion-panel>
  <hlm-separator />
  <app-input-search-filter (onFilter)="filtrer($event)" placeholder="Recherchez des activités" />
  <div>
    <a [routerLink]="['sequences', sequence().id, 'activités', 'création']" hlmBtn variant="secondary">
      <ng-icon name="lucidePlus" />
      Créer une nouvelle activité
    </a>
  </div>
  @if (activites().length || filtre()) {
    <div class="gap-md grid grid-cols-2">
      @for (item of activites(); track item.id) {
        <section
          class="border-stroke-neutral-light px-md py-sm group/item rounded-md border hover:cursor-pointer"
          (click)="navigateToDetailsActivite(item.id)"
        >
          <div class="gap-xxs grid">
            <span class="component-medium-semibold group-hover/item:underline">
              {{ item.nom }}
            </span>
            <span class="text-components-content-neutral-secondary"
              ><span class="component-small-semibold">Modalité</span> :
              <span class="component-small-medium">{{ item.modalite.nom }}</span></span
            >
            <span class="text-components-content-neutral-secondary"
              ><span class="component-small-semibold">Durée</span> :
              <span class="component-small-medium">{{ item.duree }} heures</span></span
            >
          </div>
          <hlm-separator class="bg-stroke-neutral-light" />
          <div class="pt-sm flex items-center justify-end">
            <button
              [state]="isPresentMap.get(item.id) || sequence().etat === 'Terminee' ? 'on' : 'off'"
              [disabled]="sequence().etat === 'Terminee'"
              (click)="toggleActivite(item); $event.stopPropagation()"
              hlmToggle
              hlmTooltipTrigger="Lier la séquence"
              hlmBtn
            >
              @if (isPresentMap.get(item.id)) {
                <ng-icon hlm name="lucideMinus" />
                Délier
              } @else {
                <ng-icon hlm name="lucidePlus" />
                Lier
              }
            </button>
          </div>
        </section>
      } @empty {
        <app-empty-state
          class="col-span-2"
          type="activité"
          title="Aucun résultat ne correpond à votre recherche."
          details="Modifiez vos critères de recherche pour avoir des résultats."
        ></app-empty-state>
      }
    </div>
  } @else {
    <app-empty-state title="Recherchez une activité">
      <span class="text-content-secondary text-center"
        >Tapez le nom d’une activité dans la barre de recherche pour avoir une liste d’activités correspondant à votre
        recherche.</span
      >
    </app-empty-state>
  }
</div>
